<div class="training-card mx-auto">
  <div
    class="training-flip-card"
    [class.is-flipped]="isAnswerVisible()"
    (click)="flip.emit($event)"
  >
    <article class="training-flip-face training-flip-front">
      <div class="text-uppercase text-body-secondary small fw-semibold mb-2">
        {{ t()["train.question"] }}
      </div>
      <div class="training-question rounded border bg-body-tertiary p-4">
        {{ card().frontText || t()["train.noQuestionText"] }}
      </div>
    </article>

    <article class="training-flip-face training-flip-back">
      <div class="text-uppercase text-body-secondary small fw-semibold mb-2">
        {{ t()["train.answer"] }}
      </div>
      <div class="rounded border p-4 mb-3">
        {{ card().backText || t()["train.noAnswerText"] }}
      </div>

      @if (card().options.length > 0) {
        <div class="list-group mb-3">
          @for (option of card().options; track option.id || option.text) {
            <div
              class="list-group-item d-flex align-items-center justify-content-between gap-2"
              [class.list-group-item-success]="option.isCorrect"
            >
              <span>{{ option.text }}</span>
              @if (option.isCorrect) {
                <span class="badge text-bg-success">{{
                  t()["train.correct"]
                }}</span>
              }
            </div>
          }
        </div>
      }

      @if (card().explanation) {
        <div class="alert alert-secondary py-2 mb-3">
          <strong>{{ t()["train.explanation"] }}</strong>
          <div>{{ card().explanation }}</div>
        </div>
      }

      @if (card().assets.length > 0) {
        <section>
          <div
            class="text-uppercase text-body-secondary small fw-semibold mb-2"
          >
            {{ t()["train.assets"] }}
          </div>
          <div class="d-flex flex-column gap-2">
            @for (asset of card().assets; track asset.id || asset.url) {
              @if (isImage(asset)) {
                <img
                  [src]="asset.url"
                  [alt]="asset.fileName"
                  class="img-fluid rounded border"
                />
              } @else if (isAudio(asset)) {
                <app-vidstack-player
                  class="w-100"
                  [src]="asset.url"
                  mediaType="audio"
                  [title]="asset.fileName"
                  preload="metadata"
                ></app-vidstack-player>
              } @else if (isVideo(asset)) {
                <app-vidstack-player
                  [src]="asset.url"
                  mediaType="video"
                  [title]="asset.fileName"
                  preload="metadata"
                  class="w-100 rounded border"
                ></app-vidstack-player>
              } @else {
                <a
                  [href]="asset.url"
                  target="_blank"
                  rel="noopener"
                  class="btn btn-outline-secondary text-start"
                >
                  {{ asset.fileName || t()["train.openAsset"] }}
                </a>
              }
            }
          </div>
        </section>
      }
    </article>
  </div>
</div>

@if (sessionProgressLabel()) {
  <div
    class="speak-indicator-row d-flex align-items-center justify-content-end mt-3"
  >
    <button
      type="button"
      class="btn btn-icon btn-outline-primary rounded-circle waves-effect speak-indicator-icon"
      [attr.aria-label]="sessionProgressLabel()"
      [title]="sessionProgressLabel()"
    >
      <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
        <use href="/assets/icons/sprite.svg#volume-2"></use>
      </svg>
    </button>
    <div class="text-body-secondary speak-indicator-label">
      {{ sessionProgressLabel() }}
    </div>
  </div>
}
